import { createContextManager, storeContextManager } from '@datadog/browser-core';
export function startAccountContext(configuration) {
    const accountContextManager = buildAccountContextManager();
    if (configuration.storeContextsAcrossPages) {
        storeContextManager(configuration, accountContextManager, 'rum', 4 /* CustomerDataType.Account */);
    }
    return accountContextManager;
}
export function buildAccountContextManager() {
    return createContextManager('account', {
        propertiesConfig: {
            id: { type: 'string', required: true },
            name: { type: 'string' },
        },
    });
}
//# sourceMappingURL=accountContext.js.map